// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background: var(--Secondary, #cbc5b3);
}

.main-container-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

ul.footer-menu {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 3rem;
  padding: 0px;
  list-style: none;
}

.footer-menu li a {
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  text-decoration: none;
}
.social-links-row ul {
  list-style: none;
}

img.footer-logo {
  width: auto;
}

.social-links-row ul {
  list-style: none;
  display: flex;
  gap: 31px;
  justify-content: flex-end;
}
.social-links-item a {
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-decoration: none !important;
}

.main-container-footer {
  align-items: center;
}

img.socail-icons-footer {
  padding-left: 20px;
}

.copyright-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.copyright-row {
  border-top: 2px solid #313b2f;
  margin-top: 2rem;
}

@media only screen and (min-width: 250px) and (max-width: 1199px) {
  .terms-row {
      display: flex;
      justify-content: space-around;
      padding: 0px 33px;
      flex-direction: column;
  }
  .copyright-asha {
    text-align: center;
  }
  .terms-row {
    text-align: center;
  }
  .utc-text{
    text-align: center;
  }
  .main-container-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
  }

  .copyright-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: column;
  }

  .social-links-row ul {
    list-style: none;
    display: flex;
    gap: 31px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding: 0;
}

  .social-links-item a {
    color: var(--Black, #000);
    font-family: "Helvetica Neue", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-decoration: none;
  }

  footer {
    padding: 0px 12px !important;
  }
}

.terms-row {
  display: flex;
  justify-content: space-around;
  padding: 0px 33px;
}
.terms-row p {
  padding: 0px 33px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;MACI,aAAa;MACb,6BAA6B;MAC7B,iBAAiB;MACjB,sBAAsB;EAC1B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;AACd;;EAEE;IACE,yBAAyB;IACzB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["footer {\n  background: var(--Secondary, #cbc5b3);\n}\n\n.main-container-footer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\nul.footer-menu {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 3rem;\n  padding: 0px;\n  list-style: none;\n}\n\n.footer-menu li a {\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n  text-decoration: none;\n}\n.social-links-row ul {\n  list-style: none;\n}\n\nimg.footer-logo {\n  width: auto;\n}\n\n.social-links-row ul {\n  list-style: none;\n  display: flex;\n  gap: 31px;\n  justify-content: flex-end;\n}\n.social-links-item a {\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: normal;\n  text-decoration: none !important;\n}\n\n.main-container-footer {\n  align-items: center;\n}\n\nimg.socail-icons-footer {\n  padding-left: 20px;\n}\n\n.copyright-row {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.copyright-row {\n  border-top: 2px solid #313b2f;\n  margin-top: 2rem;\n}\n\n@media only screen and (min-width: 250px) and (max-width: 1199px) {\n  .terms-row {\n      display: flex;\n      justify-content: space-around;\n      padding: 0px 33px;\n      flex-direction: column;\n  }\n  .copyright-asha {\n    text-align: center;\n  }\n  .terms-row {\n    text-align: center;\n  }\n  .utc-text{\n    text-align: center;\n  }\n  .main-container-footer {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .copyright-row {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .social-links-row ul {\n    list-style: none;\n    display: flex;\n    gap: 31px;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    padding: 0;\n}\n\n  .social-links-item a {\n    color: var(--Black, #000);\n    font-family: \"Helvetica Neue\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: normal;\n    text-decoration: none;\n  }\n\n  footer {\n    padding: 0px 12px !important;\n  }\n}\n\n.terms-row {\n  display: flex;\n  justify-content: space-around;\n  padding: 0px 33px;\n}\n.terms-row p {\n  padding: 0px 33px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
